function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_165_434)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.8965 7.51314C11.8965 9.64702 10.122 11.3769 7.93311 11.3769C5.74425 11.3769 3.96973 9.64702 3.96973 7.51314C3.96973 5.37926 5.74425 3.64941 7.93311 3.64941C10.122 3.64941 11.8965 5.37926 11.8965 7.51314Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.2448 7.51322C16.2448 9.52193 15.3575 11.1502 14.263 11.1502C13.1685 11.1502 12.2812 9.5218 12.2812 7.51322C12.2812 5.50463 13.1685 3.87622 14.263 3.87622C15.3575 3.87622 16.2448 5.50463 16.2448 7.51322Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.0229 7.51304C18.0229 9.31276 17.7109 10.7717 17.3259 10.7717C16.9409 10.7717 16.6289 9.31276 16.6289 7.51304C16.6289 5.71331 16.9409 4.25439 17.3259 4.25439C17.7109 4.25439 18.0229 5.71331 18.0229 7.51304Z",
  fill: "black"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_165_434"
}, /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 15,
  fill: "white"
})));

function SvgMediumIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumIcon);
export default __webpack_public_path__ + "static/media/medium_icon.712afef6.svg";
export { ForwardRef as ReactComponent };